import React from 'react';

import { archiveSession, unArchiveSession } from 'flow/actions/chat-actions';
import SettingsButton from 'flow/components/ui-components/SettingsButton';
import useAppContext from 'flow/hooks/useAppContext';
import { ChatSessionKey } from 'flow/types/EntityKeys';

import { Map } from 'immutable';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { useParams } from 'react-router-dom';

const Archive = () => {
    const { id } = useParams<{ id: ChatSessionKey }>();

    const { i18next } = useAppContext();
    const dispatch = useAppDispatch();

    const details = useAppSelector((state) =>
        state.chats.getIn(['sessions', id], Map()),
    );

    if (details.get('chatArchived')) {
        return (
            <SettingsButton
                iconKey="unarchive"
                onClick={() => dispatch(unArchiveSession(id))}
            >
                {i18next.t('chatsetting.unarchive')}
            </SettingsButton>
        );
    }

    return (
        <SettingsButton
            iconKey="archive"
            onClick={() => dispatch(archiveSession(id))}
        >
            {i18next.t('chatsetting.archive')}
        </SettingsButton>
    );
};

export default Archive;
